var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.946472 3.25841C0.368042 3.54079 0 4.13624 0 4.78968V7.61064C0 12.4677 2.82233 16.8642 7.19019 18.811L7.46558 18.9337C7.80627 19.0856 8.19373 19.0856 8.53442 18.9337L8.80981 18.811C13.1777 16.8642 16 12.4677 16 7.61064V4.78968C16 4.13624 15.632 3.54079 15.0535 3.25841L8.72019 0.166708C8.26485 -0.0555694 7.73515 -0.0555694 7.27981 0.166708L0.946472 3.25841Z",
    fill: "white",
    fillOpacity: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53442 18.9337L8.80981 18.811C13.1777 16.8642 16 12.4677 16 7.61064V4.78968C16 4.13624 15.632 3.54079 15.0535 3.25841L8.72019 0.166708C8.26485 -0.0555694 7.73515 -0.0555694 7.27981 0.166708L0.946472 3.25841C0.368042 3.54079 0 4.13624 0 4.78968V7.61064C0 12.4677 2.82233 16.8642 7.19019 18.811L7.46558 18.9337C7.80627 19.0856 8.19373 19.0856 8.53442 18.9337ZM1.61494 4.62776C1.56996 4.64974 1.52381 4.70734 1.52381 4.78968V7.61064C1.52381 11.8784 4.00331 15.7222 7.81054 17.4192L8 17.5036L8.18946 17.4192C11.9967 15.7222 14.4762 11.8784 14.4762 7.61064V4.78968C14.4762 4.70734 14.43 4.64974 14.3851 4.62776L8.05173 1.53607C8.01825 1.51973 7.98176 1.51972 7.94828 1.53607L1.61494 4.62776Z",
    fill: "#C2C2C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2892 6.74431C11.2079 6.66123 11.0971 6.6145 10.9815 6.6145C10.8659 6.6145 10.7552 6.66123 10.6738 6.74431L7.44475 10.018L6.08813 8.64008C5.97475 8.52641 5.80975 8.48327 5.65619 8.52714C5.50263 8.571 5.38423 8.6951 5.34624 8.852C5.30826 9.0089 5.35655 9.17437 5.47267 9.28516L7.13702 10.9703C7.2184 11.0534 7.32919 11.1001 7.44475 11.1001C7.56032 11.1001 7.6711 11.0534 7.75249 10.9703L11.2892 7.3894C11.3782 7.30632 11.4288 7.18937 11.4288 7.06685C11.4288 6.94433 11.3782 6.82739 11.2892 6.74431Z",
    fill: "#101010",
    stroke: "#101010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafeIcon);
export default __webpack_public_path__ + "static/media/safe-icon.7dff9d55aa850be984d067a9e4692b2f.svg";
export { ForwardRef as ReactComponent };